export default __webpack_public_path__ + "static/media/renew-code--desktop@2x.ac894e18.jpg";